import { useEffect } from 'react';
import { useT } from '../../i18n';
import { trackAd, useHomeBanner } from './campaigns-api';

/** Home: a running campaign's banner for the city being shown (views and taps counted per day). */
export function HomeBanner({ regionId }: { regionId: string | undefined }) {
  const q = useHomeBanner(regionId);
  const t = useT();
  const b = q.data;
  useEffect(() => {
    if (b) trackAd(b.campaignId, 'BANNER', 'VIEW');
  }, [b]);
  if (!b) return null;
  const img = (
    <>
      <img src={b.imageUrl} alt={b.brand.name} className="block w-full rounded-2xl border border-ink-700 bg-ink-850 object-cover" />
      <span className="absolute right-2 top-2 rounded-md bg-ink-950/70 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-ink-300">
        {t('Sponsored')}
      </span>
    </>
  );
  return b.link ? (
    <a
      href={b.link}
      target="_blank"
      rel="noopener noreferrer sponsored"
      onClick={() => trackAd(b.campaignId, 'BANNER', 'CLICK')}
      className="relative mt-4 block"
      data-testid="home-banner"
    >
      {img}
    </a>
  ) : (
    <div className="relative mt-4" data-testid="home-banner">
      {img}
    </div>
  );
}
